module.exports = __webpack_public_path__ + "media/entities/1003-16ea52e1.png";